import { createSlice } from "@reduxjs/toolkit";

const initState: any = {
  admin: {
    email: "",
    fullname: "",
  },
  isLoggedIn: false,
  accessToken: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initState,
  reducers: {
    setAuthReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    updateUserName: (state, action) => {
      if (state) {
        state.admin.fullname = action.payload;
      }
    },
    resetAuthReducer: () => initState,
    resetAuth: () => initState,
  },
});

export const { setAuthReducer, resetAuthReducer, updateUserName, resetAuth } =
  authSlice.actions;

export default authSlice.reducer;
